import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditServiceOrdersStatusForm from './EditServiceOrdersStatusForm'
import ModalHeader from './ModalHeader'

const EditServiceOrdersStatusModal = props => {
  return (
    <ControlledModal width="32rem" disableClickOutside {...props}>
      <PermissionChecker permission="editServiceOrdersStatus">
        <ModalHeader />
        <EditServiceOrdersStatusForm />
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditServiceOrdersStatusModal
